import C4ISR_rev from '../img/products/C4ISR_rev.jpg';
import C4ISRwebp_rev from '../img/products/C4ISR_rev.webp';
import customkitting from '../img/products/customkitting.jpg';
import customkittingwebp from '../img/products/customkitting.webp';
import deployablegear from '../img/products/deployablegear.jpg';
import deployablegearwebp from '../img/products/deployablegear.webp';
import fleet from '../img/products/fleet.jpg';
import fleetwebp from '../img/products/fleet.webp';
import gear from '../img/products/gear.jpg';
import gearwebp from '../img/products/gear.webp';
import solutions from '../img/products/solutions.jpg';
import solutionswebp from '../img/products/solutions.webp';
import weapons from '../img/products/weapons.jpg';
import weaponswebp from '../img/products/weapons.webp';

// Function to toggle accordion
function toggleAccordion(accordionItem, header) {
  const content = accordionItem.querySelector('.accordion__content');
  const icon = header.querySelector('.accordion__icon--symbol');
  const isOpen = accordionItem.classList.contains('active');

  // Close all other accordions
  document.querySelectorAll('.accordion__item').forEach(item => {
    if (item !== accordionItem) {
      item.classList.remove('active');
      item.querySelector('.accordion__content').hidden = true;
      item
        .querySelector('.accordion__header')
        .setAttribute('aria-expanded', 'false');
      item.querySelector('.accordion__icon--symbol').textContent = '+';
      const contentToHide = item.querySelector('.accordion__content');
      contentToHide.hidden = true;
    }
  });

  // Toggle current accordion
  accordionItem.classList.toggle('active');
  content.hidden = !isOpen;
  header.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  icon.textContent = isOpen ? '+' : '—';

  // Toggle the hidden attribute based on the accordion's state
  if (isOpen) {
    content.hidden = true; // Close the accordion
    header.setAttribute('aria-expanded', 'false');
    icon.textContent = '+';
  } else {
    content.hidden = false; // Open the accordion
    header.setAttribute('aria-expanded', 'true');
    icon.textContent = '—';

    // Scroll into view when accordion is opened
    header.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
}

// Add event listeners for keyboard and mouse interaction
document.querySelectorAll('.accordion__header').forEach(header => {
  header.addEventListener('click', function () {
    const accordionItem = this.parentElement;
    toggleAccordion(accordionItem, this);
  });

  // Enable toggling on Enter or Spacebar keypress
  header.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); // Prevent default scrolling for Spacebar
      const accordionItem = this.parentElement;
      toggleAccordion(accordionItem, this);
    }
  });
});

// Close accordion when clicking outside
document.addEventListener('click', function (event) {
  if (!event.target.closest('.accordion__item')) {
    document.querySelectorAll('.accordion__item').forEach(item => {
      item.classList.remove('active');
      item.querySelector('.accordion__content').hidden = true;
      item
        .querySelector('.accordion__header')
        .setAttribute('aria-expanded', 'false');
      item.querySelector('.accordion__icon--symbol').textContent = '+';
    });
  }
});
